/* eslint-disable react/forbid-prop-types */
import * as React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Container, Typography } from '@material-ui/core/';
import { Link } from 'gatsby';
import { coreRed } from '../../themeprovider/ccmTheme/colorPalette';

const useStyles = makeStyles((theme) => ({
  submissionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      marginLeft: '200px',
    },
    marginTop: '74px',
    marginBottom: '62px',
    padding: '30px',
    paddingBottom: '161px',
    paddingRight: '45px',
    backgroundColor: '#FAFAFA',
    borderRadius: '10px',
  },
  message: {
    fontSize: '24px',
    lineHeight: '140%',
  },
  hyperLink: {
    color: coreRed,
    textDecoration: 'underline',
    fontSize: '24px',
    position: 'relative',
    marginTop: '21px',
  },
}));

const FormSubmission = (props) => {
  const { messageTitle, messageBody, pageLinks } = props;

  const classes = useStyles();

  return (
    <Container
      ref={window.scrollTo(0, 0)}
      className={classes.submissionContainer}
    >
      <Typography variant="h1">{messageTitle}</Typography>
      <div className={classes.message}>{messageBody}</div>
      {pageLinks.map(({ pageLink, pageTitle }) => (
        <Link to={pageLink} className={classes.hyperLink}>
          {pageTitle}
        </Link>
      ))}
    </Container>
  );
};

export default FormSubmission;

FormSubmission.propTypes = {
  messageTitle: PropTypes.string.isRequired,
  messageBody: PropTypes.node.isRequired,
  pageLinks: PropTypes.array,
};

FormSubmission.defaultProps = {
  pageLinks: [
    {
      pageLink: '',
      pageTitle: '',
    },
  ],
};
